import type { ApiError } from '@community_dev/requests'

// Digits deliberately includes the literal `reuse_existing_domain` request param name in the
// `detail` string for both the reusable-conflict and reuse-not-found responses, specifically so
// this can key off it without a dedicated error code. Don't reword the backend copy without
// checking this stays true.
const REUSE_EXISTING_DOMAIN_PARAM = 'reuse_existing_domain'

function detailMentionsReuseParam(error: unknown): boolean {
  if (!(error instanceof Error) || error.name !== 'ApiError') return false

  const detail = (error as ApiError).errors?.[0]?.detail
  return typeof detail === 'string' && detail.includes(REUSE_EXISTING_DOMAIN_PARAM)
}

export function isReusableDomainConflict(error: unknown): boolean {
  return (error as ApiError)?.status === 409 && detailMentionsReuseParam(error)
}

export function isDomainNotFoundForReuse(error: unknown): boolean {
  return (error as ApiError)?.status === 404 && detailMentionsReuseParam(error)
}
